import React, {useEffect, useState} from 'react';
import {useTranslation} from 'react-i18next';
import collectionsService from '../services/collectionsService';
import {handleError} from '../../common/utils/errorHandling';
import {WideHeader} from '../../layout/wide';
import TilesGrid from '../../general/tiles/TilesGrid';
import {Tile, TilesGridConfig} from '../../general/tiles/types';
import {getValueWithFallback} from '../../common/types/StringTranslations';

const CollectionsListing: React.FC = () => {
  const [gridConfig, setGridConfig] = useState<TilesGridConfig>({tiles: []});
  const {t, i18n} = useTranslation();

  useEffect(() => {
    fetchCollections();
  }, []);

  const fetchCollections = async (): Promise<void> => {
    await handleError(
      async () => {
        const collections = await collectionsService.getAllCollections();

        const tilesPromises = collections.map(async (collection) => {
          const items = await collectionsService.getCollectionItems(collection.id);
          const firstImage = items[0]?.artisticObject?.firstImage;
          const imagePath = firstImage?.thumbnailPath || firstImage?.path || 'images/placeholder.jpg';
          const objectCount = items.length;

          return {
            id: collection.id,
            image: imagePath,
            title: getValueWithFallback(collection.title, i18n.language),
            subtitle: getValueWithFallback(collection.subtitle, i18n.language),
            description: getValueWithFallback(collection.description, i18n.language) || '',
            width: 2,
            height: 1,
            linkPath: `/browse-collections/${collection.id}`,
            tag: t('collections.objectCount', {count: objectCount}),
            focalPoint: firstImage?.focalPoint,
            size: firstImage ? {width: firstImage.width, height: firstImage.height} : undefined
          } as Tile;
        });

        const tiles = await Promise.all(tilesPromises);
        setGridConfig({tiles});
      },
      t('common.errors.fetchingCollections')
    );
  };

  return (
    <>
      <WideHeader
        title={t('collections.header.title')}
        introduction={t('collections.header.introduction')}
      />
      <TilesGrid config={gridConfig}/>
    </>
  );
};

export default CollectionsListing;

